<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button mat-flat-button color="primary" class="btn btn-primary" (click)="doReport()">
        <mat-icon fontIcon="report"></mat-icon>產生報表
      </button>
      <button mat-flat-button class="btn btn-secondary" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="jk-grid-cols-3">
      <div>
        <app-jkcombobox #reportTypeNo label="報表格式" [(value)]="reportType" [items]="reportTypeList"
          [showClearButton]="true">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkdaterange #mtrwd002 label="工作日期" [(valueA)]="pageOpt.date1" [(valueB)]="pageOpt.date2">
          [showClearButton]="true"
        </app-jkdaterange>
      </div>
      <div>
        <app-jkmultiselect #mtrwd021 maintable="COPMA" item="W01" label="客戶代號" valueExpr="MA001" displayExpr="MA002"
          [(values)]="pageOpt.customers">
        </app-jkmultiselect>
      </div>
    </div>
    <div class="jk-grid-cols-3">
      <div>
        <app-jkcombobox #mtrwd017 label="結案狀態" [(value)]="pageOpt.finalCode" [items]="pageOpt.finalCodeList"
          [showClearButton]="true">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkbtnedit label="工作人員" [(value)]="pageOpt.uid" maintable="CMSMV" item="W01" valueExpr="MV001"
          displayExpr="MV002" [showClearButton]="true" [showClearButton]="true" id="TD004">
        </app-jkbtnedit>
      </div>
      <div>

      </div>
    </div>
  </mat-tab>
</mat-tab-group>

